import React, { useRef, useEffect } from "react";
import { Container } from "reactstrap";

const ErrorPageHeader = () => {
  const pageHeader = useRef(null);

  useEffect(() => {
    if (window.innerWidth < 991) {
      const updateScroll = () => {
        const windowScrollTop = window.pageYOffset / 3;
        if (pageHeader.current) {
          pageHeader.current.style.transform = `translate3d(0,${windowScrollTop}px,0)`;
        }
      };
      
      window.addEventListener("scroll", updateScroll);
      
      // Cleanup function to remove event listener
      return () => {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  }, []); // Empty dependency array ensures this runs only on mount/unmount

  return (
    <>
      <div
        style={{
          backgroundImage: `url(${require("assets/img/back-alt3.png")})`,
          opacity: "0.8",
        }}
        className="page-header"
        data-parallax={true}
        ref={pageHeader}
      >
        <div className="filter" />
      </div>
      <Container>
        <div className="motto text-center">
          <h1>Oops!</h1>
          <h3>
            The link you followed may be broken, or the page may have been
            removed.
          </h3>
          <br />
        </div>
      </Container>
    </>
  );
};

export default ErrorPageHeader;
